<template>
    <div class="p-2">
        <h2>{{ $t("Ranking") }}</h2>
        <div class="container mx-auto">
            <ul class="flex justify-center space-x-2 text-white">
                <li>
                    <buttonte
                        @click="state.tab = 1"
                        class="inline-block px-4 py-2"
                        :class="{ 'text-white/50': state.tab === 2 }"
                    >
                        <i class="fa-solid fa-users"></i>
                    </buttonte>
                </li>
                <li>
                    <button
                        @click="state.tab = 2"
                        class="inline-block px-4 py-2"
                        :class="{ 'text-white/50': state.tab === 1 }"
                    >
                        <i class="fa-solid fa-shield-halved"></i>
                    </button>
                </li>
            </ul>
            <div class="p-3 mt-3">
                <div v-show="state.tab === 1">
                    <table class="top-10-table">
                        <tbody>
                        <tr v-for="(player, i) in $page.props.top10.players">
                            <td><Position :position="++i"/></td>
                            <td><Link preserve-scroll :href="route('rank.player_info', {player: player})">{{ player.name }}</Link></td>
                            <td><Empire :empire="player.empire"/></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div v-show="state.tab === 2">
                    <table class="top-10-table">
                        <tbody>
                        <tr v-for="(guild, i) in $page.props.top10.guilds">
                            <td><Position :position="++i" /></td>
                            <td><Link preserve-scroll :href="route('rank.guild_info', {guild: guild})">{{ guild.name }}</Link></td>
                            <td class="text-xs">{{ guild.ladder_point }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import Empire from "@/Shared/Empire";
import Position from "@/Shared/Position";
import {Link} from '@inertiajs/inertia-vue3'
import {reactive} from "vue";

const state = reactive({
    tab: 1
})
</script>
